module.exports = __webpack_public_path__ + "../assets/img/3e3ee629362211caeec020a13e6ceebf.jpg";